import { Box, Divider as MUIDivider, withStyles } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';

export const Wrapper = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
})(Box);

export const SearchContainer = withStyles(({ spacing }) => ({
  root: {
    padding: '8px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2)
  }
}))(Box);

export const Button = withStyles(() => ({
  root: {
    padding: 8,
    minHeight: 'max-content',
    border: 'none',
    width: 40,
    height: 40
  }
}))(SButton);

export const Divider = withStyles({
  root: {
    marginBottom: 12
  }
})(MUIDivider);
